/* Cozyleigh point estimates use USD amounts, converted from Shopify presentment currency. */
(function () {
  'use strict';

  var api = window.CozyleighPointsCurrency = {};

  function code(value) { return String(value || '').toUpperCase(); }
  function finite(value) { return typeof value === 'number' && isFinite(value); }

  api.usdMinor = function (amount, cartCurrency, shopCurrency) {
    amount = Number(amount);
    cartCurrency = code(cartCurrency);
    shopCurrency = code(shopCurrency);
    if (!finite(amount) || amount < 0 || !cartCurrency) return null;
    if (cartCurrency === 'USD') return amount;
    if (shopCurrency !== 'USD') return null;

    var currency = window.Shopify && window.Shopify.currency;
    var rate = currency && Number(currency.rate);
    if (!currency || code(currency.active) !== cartCurrency || !finite(rate) || rate <= 0) return null;
    return amount / rate;
  };

  api.pointsForProduct = function (price, ppd, currency, shopCurrency) {
    ppd = Number(ppd);
    if (!finite(ppd) || ppd <= 0) return null;
    var usd = api.usdMinor(price, currency, shopCurrency);
    return usd == null ? null : Math.floor(usd * ppd / 100 + 1e-9);
  };

  api.formatUsdAmount = function (amount, currencyCode, shopCurrency) {
    amount = Number(amount);
    currencyCode = code(currencyCode);
    shopCurrency = code(shopCurrency);
    if (!finite(amount) || amount < 0 || !currencyCode) return null;
    if (currencyCode !== 'USD') {
      var currency = window.Shopify && window.Shopify.currency;
      var rate = currency && Number(currency.rate);
      if (shopCurrency !== 'USD' || !currency || code(currency.active) !== currencyCode || !finite(rate) || rate <= 0) return null;
      amount *= rate;
    }
    try {
      var formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode });
      var digits = formatter.resolvedOptions().maximumFractionDigits;
      var factor = Math.pow(10, digits);
      amount = Math.ceil(amount * factor - 1e-9) / factor;
      return formatter.format(amount);
    }
    catch (e) { return null; }
  };

  api.pointsForCart = function (cart, ppd, shopCurrency, giftCardIds) {
    if (!cart) return null;
    var total = Number(cart.total_price);
    ppd = Number(ppd);
    if (!finite(total) || total < 0 || !finite(ppd) || ppd <= 0) return null;

    var excluded = {};
    String(giftCardIds || '').split(',').forEach(function (id) { if (id) excluded[id] = true; });
    (cart.items || []).forEach(function (item) {
      if (!excluded[String(item.product_id)]) return;
      var line = Number(item.final_line_price != null ? item.final_line_price : item.line_price);
      if (finite(line) && line > 0) total = Math.max(0, total - line);
    });

    var currency = cart.presentment_currency || cart.currency;
    var usd = api.usdMinor(total, currency, shopCurrency);
    return usd == null ? null : Math.floor(usd * ppd / 100 + 1e-9);
  };

  function format(n) {
    try { return Number(n).toLocaleString('en-US'); } catch (e) { return String(n); }
  }

  function update(cart) {
    var recs = document.querySelector('[data-cl-recs][data-context="cart"]');
    var summary = document.querySelector('[data-cl-pts]');
    var goal = document.querySelector('[data-clpp-goal][data-context="cart"]');
    var box = document.querySelector('[data-clpp-cart]');
    // the cart page's hidden carrier (sections/main-cart): keeps this event firing now the old points markup is gone
    var meta = document.querySelector('[data-cl-cart-meta]');
    var source = recs || summary || goal || box || meta;
    if (!source) return;

    var rateSource = recs || summary || goal || meta;
    var ppd = rateSource ? Number(rateSource.getAttribute('data-ppd')) || 0 : 0;
    var shopCurrency = source.getAttribute('data-shop-currency');
    var giftCardIds = source.getAttribute('data-gift-card-ids') || (summary && summary.getAttribute('data-gift-card-ids')) || '';
    if (cart && !cart.presentment_currency && !cart.currency) {
      cart = Object.assign({}, cart, { currency: source.getAttribute('data-cart-currency') });
    }
    var cartCurrency = cart && (cart.presentment_currency || cart.currency);
    var points = api.pointsForCart(cart, ppd, shopCurrency, giftCardIds);

    [recs, summary, goal, box, meta].forEach(function (el) {
      if (!el) return;
      if (cartCurrency) el.setAttribute('data-cart-currency', cartCurrency);
      if (cart && cart.total_price != null) el.setAttribute('data-subtotal', cart.total_price);
    });

    if (points == null) {
      if (summary) summary.hidden = true;
      if (goal) goal.hidden = true;
      if (window.console && console.warn) console.warn('Cozyleigh Points cart amount could not be converted to USD.');
      return;
    }

    if (recs) recs.setAttribute('data-cart-pts', points);
    if (goal) goal.setAttribute('data-pts', points);

    if (summary) {
      var fill = summary.querySelector('.cl-pts__fill');
      var value = summary.querySelector('[data-cl-points-value]');
      if (fill) fill.style.setProperty('--f', Math.min(1, points / 2000));
      if (value) value.textContent = format(points);
      Array.prototype.forEach.call(summary.querySelectorAll('[data-points-threshold]'), function (tick) {
        tick.classList.toggle('on', points >= Number(tick.getAttribute('data-points-threshold')));
      });
      summary.setAttribute('data-points', points);
      summary.hidden = points <= 0;
    }

    try {
      document.dispatchEvent(new CustomEvent('clpp:cart-points-updated', { detail: { points: points, cart: cart } }));
    } catch (e) {}
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed: ' + response.status);
        return response.json();
      })
      .then(update)
      .catch(function (error) {
        if (window.console && console.error) console.error('Unable to update Cozyleigh Points for the cart.', error);
      });
  }

  function updateProductPoints(root) {
    var nodes = (root || document).querySelectorAll('[data-cl-product-points]');
    Array.prototype.forEach.call(nodes, function (node) {
      var amount = Number(node.getAttribute('data-price'));
      var pts = api.pointsForProduct(amount, node.getAttribute('data-ppd'),
        node.getAttribute('data-presentment-currency'), node.getAttribute('data-shop-currency'));
      var pointsText = node.querySelector('[data-cl-product-points-value]');
      var scope = (node.closest && node.closest('.cl-points-wrap')) || node.parentNode;
      var goal = scope && scope.querySelector('[data-clpp-goal][data-context="product"]');
      if (pts == null || pts <= 0) {
        node.hidden = true;
        if (goal) goal.hidden = true;
        return;
      }
      if (pointsText) pointsText.textContent = format(pts);
      var worth = node.querySelector('[data-cl-product-points-worth]');
      // One short line beside the points: the estimate's worth, and that points land after checkout.
      var worthText = '≈ $' + (pts / 100).toFixed(2) + (node.getAttribute('data-presentment-currency') === 'USD' ? '' : ' USD') + ' toward a reward';
      if (worth) worth.textContent = '(' + worthText + ', after checkout)';
      node.setAttribute('data-pts', pts);
      node.hidden = false;
      if (goal) goal.setAttribute('data-pts', pts);
      try {
        document.dispatchEvent(new CustomEvent('clpp:product-points-updated', { detail: { points: pts, node: node } }));
      } catch (e) {}
    });
  }

  function updateProductVariant(event) {
    var variant = event && event.detail && event.detail.variant;
    if (!variant || variant.price == null) return;
    var area = event.target && event.target.closest && event.target.closest('.product-area');
    if (!area) return;
    var node = area.querySelector('[data-cl-product-points]');
    if (!node) return;
    node.setAttribute('data-price', variant.price);
    updateProductPoints(area);
  }

  updateProductPoints();
  document.addEventListener('on:variant:change', updateProductVariant);
  document.addEventListener('shopify:section:load', function (event) { updateProductPoints(event.target); });
  try { document.dispatchEvent(new CustomEvent('clpp:currency-ready')); } catch (e) {}

  if (document.querySelector('[data-cl-recs][data-context="cart"], [data-cl-pts], [data-clpp-goal][data-context="cart"], [data-cl-cart-meta]')) {
    refresh();
    var total = document.querySelector('[data-merge="total"]');
    if (total && window.MutationObserver) {
      var timer;
      var subtotalText = function () {
        var amount = total.querySelector('.subtotal .amount');
        return amount ? amount.textContent.trim() : '';
      };
      var lastSubtotal = subtotalText();
      new MutationObserver(function () {
        // update() writes the points line inside this same block, so only a new subtotal means the cart changed;
        // reacting to every mutation re-fetched /cart.js in a loop
        var now = subtotalText();
        if (now === lastSubtotal) return;
        lastSubtotal = now;
        clearTimeout(timer);
        timer = setTimeout(refresh, 300);
      }).observe(total, { childList: true, subtree: true, characterData: true });
    }
  }
})();
